export default [
  {
    field: 'employerAddress',
    method: 'isEmpty',
    validWhen: false,
    message: 'Employer address is required',
  },
  {
    field: 'employerAddress',
    method: 'isLength',
    validWhen: true,
    message: 'Employer address is required',
    options: [{ min: 1 }],
  },
  {
    field: 'employerCity',
    method: 'isEmpty',
    validWhen: false,
    message: 'Employer city is required',
  },
  {
    field: 'employerCity',
    method: 'isLength',
    validWhen: true,
    message: 'Employer city is required',
    options: [{ min: 1 }],
  },
  {
    field: 'employerPostalCode',
    method: 'isEmpty',
    validWhen: false,
    message: 'Employer postal code is required',
  },
  {
    field: 'employerPostalCode',
    method: 'isLength',
    validWhen: true,
    message: 'Employer postal code is required',
    options: [{ min: 1 }],
  },
  {
    field: 'employerProvince',
    method: 'isEmpty',
    validWhen: false,
    message: 'A selection is required',
  },
  {
    field: 'employerProvince',
    method: 'isLength',
    validWhen: true,
    message: 'A selection is required',
    options: [{ min: 1 }],
  },
];
